<script>
  import { onMount } from "svelte";
  import { navigate } from "svelte-navigator";
  import {
    Card,
    TextInput,
    Button,
    DatePicker,
    Textarea,
    FileUpload,
  } from "../../components/index.svelte";
  import {
    getProperty,
    getReservationDetails,
    updateReservation,
    createReservation,
  } from "../../helpers/apiHelpers/index.svelte";
  import { toast } from "../../helpers/utils.svelte";
  import { translator } from "../../store";

  export let reservationID;
  export let propertyID;
  export let formType;

  let reservationDetails;
  let propertyDetails;

  function getFormTitle(formType) {
    let formTitle = "";
    switch (true) {
      case formType === "new":
        formTitle = "Yeni Rezervasyon Bilgileri";
        break;
      case formType === "edit":
        formTitle = "Rezervasyon Bilgilerini Düzenle";
        break;
    }
    return translator(formTitle);
  }

  onMount(async () => {
    try {
      propertyDetails = await getProperty(propertyID);
      if (reservationID) {
        reservationDetails = await getReservationDetails(reservationID);
      }
    } catch (err) {
      toast.error(
        translator("Hata"),
        translator(
          err.getResponseMessage ? err.getResponseMessage() : err.message
        )
      );
    }
  });

  async function handleSubmit(e) {
    const reservationFormData = new FormData(e.target);
    // TODO :: Reservation Images
    try {
      let response = null;
      if (formType === "edit") {
        response = await updateReservation(
          propertyID,
          reservationID,
          reservationFormData
        );
      } else {
        response = await createReservation(propertyID, reservationFormData);
      }
      if (response.id) {
        toast.success(
          translator("Başarılı"),
          formType === "edit"
            ? translator("Değişiklikler Kaydedildi")
            : translator("Rezervasyon oluşturuldu")
        );
        navigate(-1);
      }
    } catch (err) {
      toast.error(
        translator("Hata"),
        translator(
          err.getResponseMessage ? err.getResponseMessage() : err.message
        )
      );
    }
  }
</script>
<Card headerText={getFormTitle(formType)}>
  <form
    class="basic-form"
    id="user-form"
    on:submit|preventDefault={handleSubmit}
  >
    <div class="row">
      <div class="col-md-12 p-2">
        <FileUpload
          fieldName="profile_picture"
          multiple={false}
          label={translator("Profil fotoğrafı")}
          required={false}
          selectedFiles={reservationDetails?.pp_file ? [reservationDetails.pp_file] : []}
        />
      </div>
      <div class="col-md-12 p-2">
        <TextInput
          fieldName="guest_name"
          label="Misafirin Adı Soyad"
          required
          value={reservationDetails?.guest_name}
        />
      </div>
      <div class="col-md-3 col-sm-6 p-2">
        <TextInput
          fieldName="adult_count"
          labelText="Yetişkin Sayısı"
          label="Yetişkin Sayısı"
          required
          value={reservationDetails?.adult_count}
        />
      </div>
      <div class="col-md-3 col-sm-6 p-2">
        <TextInput
          fieldName="child_count"
          labelText="Çocuk Sayısı"
          label="Çocuk Sayısı"
          value={reservationDetails?.child_count || 0}
        />
      </div>
      <div class="col-md-3 col-sm-6 p-2">
        <TextInput
          fieldName="baby_count"
          labelText="Bebek Sayısı"
          label="Bebek Sayısı"
          value={reservationDetails?.baby_count || 0}
        />
      </div>
      <div class="col-md-3 col-sm-6 p-2">
        <TextInput
          fieldName="animal_count"
          labelText="Hayvan Sayısı"
          label="Hayvan Sayısı"
          value={reservationDetails?.animal_count || 0}
        />
      </div>
      <div class="col-md-12 p-2">
        <Textarea
          fieldName="notes"
          labelText="Bilgi Notları"
          label="Bilgi Notları"
          value={reservationDetails?.notes}
        />
      </div>
      <div class="col-md-6 p-2">
        <DatePicker
          fieldName="check_in"
          value={reservationDetails?.check_in}
          label="Check-in Tarihi"
          required
        />
      </div>
      <div class="col-md-6 p-2">
        <DatePicker
          fieldName="check_out"
          value={reservationDetails?.check_out}
          label="Check-out Tarihi"
          required
        />
      </div>
      <div class="col-md-6 p-2">
        <TextInput
          fieldName="total_price"
          labelText="Toplam Tutar"
          label="Toplam Tutar"
          type="number"
          step="0.01"
          value={reservationDetails?.total_price}
        />
        <div class="pt-2">
          {translator('Temizlik tutarı (Otomatik olarak eksitilecektir): __CLEANINGFEE__', {
            __CLEANINGFEE__: propertyDetails?.cleaning_fee
          })}
        </div>
      </div>
      <div class="col-md-6 p-2">
        <TextInput
          fieldName="commission_rate"
          labelText="Komisyon Oranı"
          label="Komisyon Oranı"
          type="number"
          step="0.01"
          value={reservationDetails?.commission_rate ||
            propertyDetails?.commission_rate}
        />
      </div>
    </div>
    <hr />
    <div class="gap-2 d-flex justify-content-end align-items-center">
      <Button formName="user-form" colorCls="btn-success">
        {translator("Kaydet")}
      </Button>
      <Button onClick={() => navigate(-1)} colorCls="btn-dark">
        {translator("Vazgeç")}
      </Button>
    </div>
  </form>
</Card>
